


















import ActionButton from '@/components/ActionButton.vue'
import { Remittance } from '@/utils/interfaces/remittance.interface'
import Messages from './Messages.vue'
import Vue, { PropType } from 'vue'
import { createRemittanceMessage } from '@/api/Remittances/remittances.api'

export default Vue.extend({
  components: {
    appActionButton: ActionButton,
    appMessages: Messages,
  },
  props: {
    remittance: Object as PropType<Remittance>,
  },
  data() {
    return {
      dialog: false,
      messages: this.remittance.messages.reverse(),
    }
  },
  methods: {
    async poster(message: string) {
      return await createRemittanceMessage({
        message: message,
        remittance: this.remittance.remittance,
      })
    },
  },
})
